import authorizationRegistry from '../generated/authorizationRegistry.json';

// Aliases are registry metadata, not browser authorization policy.
export const MODULE_ID_ALIASES = Object.freeze({
  ...authorizationRegistry.aliases,
  worship: 'worship',
});

export const canonicalizeModuleId = (moduleId) => MODULE_ID_ALIASES[moduleId] || moduleId;

export const canonicalizeModuleIds = (moduleIds = []) => Array.from(new Set(
  (Array.isArray(moduleIds) ? moduleIds : []).map(canonicalizeModuleId),
));
